import { Navigate, Outlet } from 'react-router-dom';
import { useCognitoUserContext } from '../AWSCognitoWrapper/context';
import { routes } from 'router/routes';

/** A gate wrapper that when a user is authenticated, redirects to the root
 * Meant for routes that are only meant to be seen by unauthenticated users (invitation link, reset password, etc)
 */
export const UnauthenticatedGate: React.FC = () => {
  const { isLoggedIn } = useCognitoUserContext();

  if (isLoggedIn) {
    return <Navigate to={routes.root} />;
  }

  return <Outlet />;
};
